import {
  getNotifications,
  getNotificationCount,
  markNotificationAsRead,
  markAllNotificationsAsRead,
  deleteNotification,
  clearNotifications,
} from "./utils";

class HttpNotificationClient {
  async #handleRequest(apiCall) {
    try {
      const response = await apiCall;
      return {
        success: true,
        data: response.data.data,
        meta: response.data.meta,
        status: response.status,
        message: response.data.message,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data || error.message,
        status: error.response?.status || 500,
      };
    }
  }

  getNotifications(params = {}) {
    return this.#handleRequest(getNotifications(params));
  }

  getNotificationCount() {
    return this.#handleRequest(getNotificationCount());
  }

  markNotificationAsRead(notificationId) {
    return this.#handleRequest(markNotificationAsRead(notificationId));
  }

  markAllNotificationsAsRead() {
    return this.#handleRequest(markAllNotificationsAsRead());
  }

  deleteNotification(notificationId) {
    return this.#handleRequest(deleteNotification(notificationId));
  }

  clearNotifications() {
    return this.#handleRequest(clearNotifications());
  }
}

const Notification = new HttpNotificationClient();
Object.freeze(Notification);

export default Notification;
